module.exports = __webpack_public_path__ + "static/media/parramatta.220c034c.jpg";